<app-screen-content [isLoading]="model.isLoading">
  <ng-container title>
    <img src="assets/icons/ic-risk@3x.svg" alt="" />
    <span>Risk and objectives</span>
  </ng-container>

  <ng-container instruction>
    Please answer all questions completely, honestly and accurately. These
    questions allow us to understand how much risk your organisation wants to
    take. Omission of, or the provision of inaccurate or incomplete data will
    reduce and affect the quality of investment advice or recommendation(s) we
    provide to you.
  </ng-container>

  <div body>
    <form [formGroup]="form" (ngSubmit)="model.onSubmit()">
      <ng-container formArrayName="questions">
        <section
          class="box"
          *ngFor="
            let questionControl of questionsFormArray.controls;
            index as questionListIndex
          "
        >
          <ng-container
            [formGroupName]="questionListIndex"
            *ngIf="model.questionList[questionListIndex]; let questionList"
          >
            <div class="section-title">
              {{ questionList.category }}
            </div>
            <div
              class="qna-group"
              *ngFor="let question of questionList.questions"
            >
              <div class="question-index">{{ question.index + 1 }}.</div>
              <div>
                <div class="question">{{ question.label }}</div>

                <div class="radio-group">
                  <div *ngFor="let option of question.options">
                    <app-basic-radio
                      [name]="question.id"
                      [label]="option.title"
                      [description]="option.description"
                      [value]="questionControl.get(question.id)?.value"
                      [radioValue]="option.id"
                      [formControlName]="question.id"
                    ></app-basic-radio>
                  </div>
                </div>

                <!-- Showing error method -->
                <div
                  *ngIf="
                    questionControl.get(question.id)?.touched &&
                    questionControl.get(question.id)?.errors?.required
                  "
                  class="error fna-mt-10"
                >
                  Please select an option
                </div>
              </div>
            </div>
          </ng-container>
        </section>
      </ng-container>
      <div class="bottom-nav">
        <app-back-button (click)="goToPreviousScreen()"></app-back-button>
        <app-next-button buttonType="submit"></app-next-button>
      </div>
    </form>
    <div *ngIf="globals.isDebug">
      <h3>Information for developers, please ignore</h3>
      <h4>Data</h4>
      <pre class="debug-log-mono">{{ model.data | json }}</pre>
      <h4>Model</h4>
      <h5>Form value</h5>
      <pre class="debug-log-mono">{{ form.value | json }}</pre>
    </div>
  </div>
</app-screen-content>
